import { NgModule } from '@angular/core';

import { NovoIconComponent } from './Icon';

@NgModule({
  exports: [NovoIconComponent],
  declarations: [NovoIconComponent],
})
export class NovoIconModule {}
